import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import InformationIcon from 'zignal-landscape/lib/Icon/InformationIcon';
import landscapeColors from 'zignal-landscape/lib/styles/colors.css';

const InfoBox = ({
  message,
  hideIcon = false,
  styles,
  inline = false,
  small = false
}) => (
  <div className={`${styles.errorContainer} ${small ? styles.small : ''}`} data-cy="info-box">
    <div className={`${styles.errorContentWrapper} ${inline ? styles.inline : ''}`}>
      {!hideIcon && <InformationIcon width="2.8em" height="2.8em" color={landscapeColors.blue07} />}
      <p className={`${styles.errorMessage} ${inline ? styles.inlineMessage : ''}`}>
        {message}
      </p>
    </div>
  </div>
);

InfoBox.propTypes = {
  message: PropTypes.string.isRequired,
  hideIcon: PropTypes.bool,
  styles: PropTypes.object.isRequired,
  inline: PropTypes.bool,
  small: PropTypes.bool
};

export default themeable(InfoBox);
